import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt, getDoc } from '@angular/fire/firestore';
import moment from 'moment';

import { map } from 'rxjs/operators';

import { Ticket } from '../classes/index';

@Injectable()
export class TicketService {

	constructor(private firestore: Firestore) {
		console.log('VoucherService initialization...');
	}

	listTickets(){
		return collectionData(query(collection(this.firestore, 'tickets')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let ticket = new Ticket();
				ticket.fromJSON(doc);
				return ticket;
			});
		}));
	}

	getTicket(ticketId){
		return docData(doc(this.firestore, `tickets/${ticketId}`), { idField: 'id' })
		.pipe(map(data => {
			let ticket = new Ticket();
			ticket.fromJSON(data);
			return ticket;
		}));
	}

	listTicketsByTime(dateDebut, dateFin){
		var start = moment(dateDebut).startOf('day').valueOf();
		var end = moment(dateFin).endOf('day').valueOf();
		return collectionData(query(collection(this.firestore, 'tickets'), where("orderTime", ">=", start), 
			where("orderTime", "<=", end), orderBy('orderTime','desc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let ticket = new Ticket();
				ticket.fromJSON(doc);
				return ticket;
			});
		}));
	}

	retry(ticketId, data){
		return updateDoc(doc(this.firestore, `tickets/${ticketId}`), data);
	}

	findTicket(email){
		return collectionData(query(collection(this.firestore, 'tickets'), where('email', '==', email)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let ticket = new Ticket();
				ticket.fromJSON(doc);
				return ticket;
			});
		}))
	}

	findTicketByOtaBookingRef(bookingRef){
		return collectionData(query(collection(this.firestore, 'tickets'), where('bookingRef', '==', bookingRef)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let ticket = new Ticket();
				ticket.fromJSON(doc);
				return ticket;
			});
		}))
	}

	findTicketByCoddyRefNumber(refNumber){
		return collectionData(query(collection(this.firestore, 'tickets'), where('refNumber', '==', refNumber)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let ticket = new Ticket();
				ticket.fromJSON(doc);
				return ticket;
			});
		}))
	}
	
	addTicket(ticket) {
		return addDoc(collection(this.firestore, 'tickets'), {...ticket});
	}

	deleteVoucher(ticketId) {
		return deleteDoc(doc(this.firestore, `tickets/${ticketId}`));
	}

	getEmailTemplate(name){
		return docData(doc(this.firestore, `email_templates/${name}`));
	}
}
